module.exports = __webpack_public_path__ + "static/D1000-6173a0bc80442d3d15471bdea13a5000.png";